module.exports = __webpack_public_path__ + "img/service_bg.6e5769d.webp";